import Error from '.Error';
import TypeError from '.TypeError';
import undefined from '.undefined';

let ing          = false;

export const on = ()       => {
	if ( ing ) { throw Error(`transpiling`); }
	ing = true;
};

export let ts         = '';
export const set_ts = (value        )       => {
	if ( typeof value!=='string' ) { throw TypeError(`transpileModule(!string)`); }
	ts = value;
};

export let filename                    ;
export const set_filename = (value                    )       => {
	if ( typeof value==='string' ) { filename = value; }
	else if ( value!==undefined ) { throw TypeError(`transpileModule(,,!string)`); }
};

export const off = ()       => {
	ts = '';
	filename = undefined;
	ing = false;
};
